export const getQueryStringPartner = () => {
  if (typeof window === "undefined") return ""

  const urlParams = new URLSearchParams(window.location.search)
  const params = new URLSearchParams()

  const token = urlParams.get("token") || localStorage.getItem("partner-token")
  const customerId = urlParams.get("customer_id") || localStorage.getItem("customer_id")
  const requestId = urlParams.get("request_id") || localStorage.getItem("request_id")
  const source = urlParams.get("source") || localStorage.getItem("booking_source")
  const partnerId = urlParams.get("partner_id")
  const skyscannerRedirectId = urlParams.get("skyscanner_redirectid")

  if (token) params.set("token", token)
  if (customerId) params.set("customer_id", customerId)
  if (requestId) params.set("request_id", requestId)
  if (source) params.set("source", source)
  if (partnerId) params.set("partner_id", partnerId)
  if (skyscannerRedirectId) params.set("skyscanner_redirectid", skyscannerRedirectId)

  return params.toString()
}